// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-3XoUD","expired":"expired-1eOPG","content":"content-2nuhY","logo":"logo-2Bg6n"};